import AdminRoutes from './admin';

export const Routes = [
    ...AdminRoutes
]

export default Routes
